const s = "af.filter-sidebar.technology-filter-toggled", t = class t extends CustomEvent {
  constructor(o) {
    super(s, { detail: { fontTechnology: o }, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let e = t;
export {
  s as EVENT_NAME,
  e as default
};
//# sourceMappingURL=TechnologyFilterToggleEvent.js.map
